export default __webpack_public_path__ + "static/media/un.1e5529d8.png";